import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { NotificationsService } from 'angular2-notifications';

import { ResourcesService } from '../../../../services/resources/resources.service';
import { EventsService } from '../../../../services/events/events.service';

@Component({
  selector: 'modal-delete',
  styleUrls: [('./modalDelete.scss')],
  templateUrl: './modalDelete.html'
})

export class ModalDelete {

  modalHeader: string;
  idData: number;
  type: string;
  code: string;
  withConfirm: boolean = false;
  password = '';
  motivo = '';

  constructor(
    private activeModal: NgbActiveModal,
    private _notificationService: NotificationsService,
    private _resourcesService: ResourcesService,
    private _eventsService: EventsService) {
    this.idData = 0;
    this.type = '';
  }

  ngOnInit() { }

  public closeModal() {
    this.activeModal.close();
  }

  public delete() {
    if (this.withConfirm) {
      if (this.password == 'borrartodo')
        this.applyDelete();
      else
        this._notificationService.error('Mensaje', 'No se pudo eliminar a fila.');
    } else if (!this.withConfirm) {
      this.applyDelete();
    }
  }

  private applyDelete() {
    switch (this.type) {
      case 'HourRegister':
        this._resourcesService.deleteHourRegister(this.idData, this.motivo.trim())
          .subscribe(
          result => {console.log(result)
         this.closeModalT();  
        },
          error => this._notificationService.error('Mensaje', (error && error.error) || 'No se pudo eliminar el fichaje.')
          );
        break;
      case 'Personal':
        this._resourcesService.deletePersonal(this.idData)
          .subscribe(
          result => {
            console.log(result);
            this.closeModalT(); 
          },
          error => console.log(error)
          );
        break;
      case 'Usuario':
        this._resourcesService.deleteUser(this.idData)
          .subscribe(
          result => {
            console.log(result);
            this.closeModalT(); 
          },
          error => console.log(error)
          );
        break;
      default:
    }
  }

  private closeModalT() {
    this._eventsService.setDeletedId(this.idData);
    this.activeModal.close();
  }

}



// WEBPACK FOOTER //
// /app/src/app/theme/components/modals/components/modalDelete/modalDelete.component.ts